import { useContext } from 'react';
import { StoreContext,SupplierStoreContext } from './store-provider';
import Store from "../store/store";
import SupplierStore from "../store/supplierStore";

export const useStore = (): Store => useContext(StoreContext);
export const useSupplierStore = (): SupplierStore => useContext(SupplierStoreContext);